// extracted by mini-css-extract-plugin
export var header = "_te-1";
export var maskBottom = "_te-6";
export var maskMiddle = "_te-7";
export var maskTop = "_te-5";
export var root = "_te-0";
export var scrollDownButton = "_te-3";
export var scrollDownButtonHidden = "_te-4";
export var viewport = "_te-2";